module.exports = __webpack_public_path__ + "static/media/gardenSensor.e3222b0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gardenSensor.jpg
// module id = 170
// module chunks = 0